// extracted by mini-css-extract-plugin
module.exports = {"OrderSummary":"OrderSummary_OrderSummary__2A4xL","ingredient":"OrderSummary_ingredient__32vQj","price":"OrderSummary_price__PIhx5"};